import { render, staticRenderFns } from "../views/db_info.html?vue&type=template&id=5d188898&scoped=true&"
import script from "../scripts/db_info.ts?vue&type=script&lang=ts&"
export * from "../scripts/db_info.ts?vue&type=script&lang=ts&"
import style0 from "./db_info.vue?vue&type=style&index=0&id=5d188898&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d188898",
  null
  
)

/* vuetify-loader */
import installComponents from "!/home/ujjwal/projects/opensource/idbstudio/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VExpansionPanel } from 'vuetify/lib'
import { VExpansionPanelContent } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
installComponents(component, {VExpansionPanel,VExpansionPanelContent,VFlex,VLayout,VSelect})


/* hot reload */
if (module.hot) {
  var api = require("/home/ujjwal/projects/opensource/idbstudio/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('5d188898', component.options)
    } else {
      api.reload('5d188898', component.options)
    }
    module.hot.accept("../views/db_info.html?vue&type=template&id=5d188898&scoped=true&", function () {
      api.rerender('5d188898', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/component/db_info.vue"
export default component.exports